import axios from "axios";

const BASE = `${process.env.REACT_APP_BACKEND_URL}/api/re`;
const headers = () => {
  const t = localStorage.getItem("nex_token");
  return t ? { Authorization: `Bearer ${t}` } : {};
};

export const reApi = {
  get: (path, params) => axios.get(`${BASE}${path}`, { headers: headers(), params }).then((r) => r.data),
  post: (path, body) => axios.post(`${BASE}${path}`, body, { headers: headers() }).then((r) => r.data),
  patch: (path, body) => axios.patch(`${BASE}${path}`, body, { headers: headers() }).then((r) => r.data),
  put: (path, body) => axios.put(`${BASE}${path}`, body, { headers: headers() }).then((r) => r.data),
  del: (path) => axios.delete(`${BASE}${path}`, { headers: headers() }).then((r) => r.data),
  upload: (form) => axios.post(`${BASE}/documents/upload`, form, { headers: headers() }).then((r) => r.data),
  fileBlob: (id) => axios.get(`${BASE}/documents/${id}/file`, { headers: headers(), responseType: "blob" }).then((r) => r.data),
  blob: (path) => axios.get(`${BASE}${path}`, { headers: headers(), responseType: "blob" }).then((r) => r.data),
};

/** Saves a blob to the device as a file (no new tab). */
export const saveBlob = (blob, name) => {
  const u = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = u; a.download = name; document.body.appendChild(a); a.click(); a.remove();
  setTimeout(() => URL.revokeObjectURL(u), 60000);
};

export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (Array.isArray(d)) return d.map((x) => x.msg || x).join(", ");
  if (d && typeof d === "object") return d.message || JSON.stringify(d);
  return d || e?.message || "Request failed";
};

export const fmtDate = (v) => (v ? String(v).slice(0, 10) : "—");
export const fmtDateTime = (v) => {
  if (!v) return "—";
  const d = new Date(v);
  return Number.isNaN(d.getTime()) ? String(v) : d.toLocaleString([], { dateStyle: "medium", timeStyle: "short" });
};
export const pretty = (s) => (s ? String(s).replace(/_/g, " ") : "—");

/** Adapter so finance WorkflowContent can drive /api/re/* workflow-shaped routes (e.g. weekly check-ins). */
export const reWorkflowClient = { get: reApi.get, post: reApi.post, patch: reApi.patch };
const PREF = (k) => `tea_resident_${k}`;
export const rePref = { get: (k, f) => localStorage.getItem(PREF(k)) || f, set: (k, v) => localStorage.setItem(PREF(k), v) };
export const INTAKE_TONE = { not_started: "dim", in_progress: "yellow", complete: "green" };
export const INTAKE_LABEL = { not_started: "Not started", in_progress: "In progress", complete: "Complete" };
